import React from 'react';
import MUIButton from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';

import { InProgress } from '../../in-progress/InProgress.view';

import './style.css';

const useStyles = makeStyles((theme) => ({
  label: {
    letterSpacing: 0,
  },
  root: {
    textTransform: 'none',
  },
  containedSecondary: {
    main: theme.palette.warning.main,
  },
  iconSizeSmall: {
    height: '1rem',
    width: '1rem',
    '& > svg': {
      width: '16px',
      height: '16px',
    },
  },
}));

const Button: React.FC<
  React.ComponentProps<typeof MUIButton> & {
    icon?: React.ReactNode;
    text?: string;
    theme?: 'default' | 'primary' | 'secondary' | 'danger';
    loading?: boolean;
    children?: React.ReactNode;
    loadingText?: string;
    active?: boolean;
    classesFromProps?: Record<string, string>;
    className?: string;
  }
> = ({
  icon,
  text = 'go',
  theme = 'default',
  variant = 'contained',
  loading = false,
  children,
  loadingText,
  active = false,
  size = 'small',
  classesFromProps,
  className = '',
  ...restProps
}) => {
  const classes = useStyles();
  const finalClassNames = [className, 'button', active ? 'button--active' : ''].join(' ').trim();
  const color = theme === 'danger' ? 'secondary' : theme;

  return (
    <MUIButton
      className={finalClassNames}
      disableElevation
      variant={variant}
      color={color}
      classes={{
        label: classes.label,
        root: classes.root,
        iconSizeSmall: classes.iconSizeSmall,
        ...classesFromProps,
      }}
      size={size}
      startIcon={icon}
      {...restProps}
    >
      {loading ? (
        <div>
          <InProgress inverted={true} size="small" />
          <span className="button__text">{loadingText}</span>
        </div>
      ) : children ? (
        <span className="button__text">{children}</span>
      ) : (
        <span className="button__text">{text}</span>
      )}
    </MUIButton>
  );
};

export default Button;
